import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { thinkingPluginKey } from '../pm-plugins/thinking-plugin';

import type { RetryThinkingAction } from './types';

/**
 * Return a failed session to `thinking` (clearing the error) so the caller can
 * re-run the same skill. Does not re-trigger the request itself.
 */
export const retryThinkingAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => RetryThinkingAction =
	(api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) => (): boolean => {
		return (
			api?.core?.actions.execute(({ tr }) => {
				tr.setMeta(thinkingPluginKey, {
					status: 'thinking',
				});
				return tr;
			}) || false
		);
	};
